<template>
    <div id="page" class="page">

        <interne_menu></interne_menu>

        <!-- Mentions legales -->
        <section id="faqs-1" class="bg-fixed bg-lightgrey wide-60 faqs-section pro_part division ">
            <div class="container">


                <!-- SECTION TITLE -->
                <div class="row">
                    <div class="col-md-10 offset-md-1 section-title ">

                        <!-- Title 	-->
                        <h2 class="h2-lg">Nos astuces APAYM</h2>


                    </div> 	 <!-- End row -->
                </div>
                <!-- END SECTION TITLE -->

                <div class="row">

                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-10 offset-md-1 sect_tuto">
                     <img src="@/assets/images/tuto1.webp" class="im_tuto">
                    </div>
                    <!-- END  QUESTIONS HOLDER -->

                    <div class="col-lg-10 offset-lg-1">
                        <div class="press-txt text-center m-top-20">

                            <!-- Button -->
                            <RouterLink to="" class="btn btn-lightorange tuto-space" @click="ytb_tutos('https://youtube.com/embed/82qfpDlG5fw?feature=share')"><span class="pe-7s-play color_v"></span> Regarder le tuto</RouterLink>

                        </div>
						</div>

                </div>
                <!-- End row -->

                <div class="row">

                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-10 offset-md-1 sect_tuto">
                     <img src="@/assets/images/tuto2.webp" class="im_tuto">
                    </div>
                    <!-- END  QUESTIONS HOLDER -->

                    <div class="col-lg-10 offset-lg-1">
                        <div class="press-txt text-center m-top-20">

                            <!-- Button -->
                            <RouterLink to="" class="btn btn-lightorange tuto-space " @click="ytb_tutos('https://www.youtube.com/embed/ljaY-FdpDiU')"><span class="pe-7s-play color_v"></span> Regarder le tuto</RouterLink>

                        </div>
						</div>

                </div>
                <!-- End row -->


                <div class="row">

                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-10 offset-md-1 sect_tuto">
                     <img src="@/assets/images/tuto3.webp" class="im_tuto">
                    </div>
                    <!-- END  QUESTIONS HOLDER -->

                    <div class="col-lg-10 offset-lg-1">
                        <div class="press-txt text-center m-top-20">

                            <!-- Button -->
                            <RouterLink to="" class="btn btn-lightorange tuto-space " @click="ytb_tutos('https://www.youtube.com/embed/SlTacn49K0g')"><span class="pe-7s-play color_v"></span> Regarder le tuto</RouterLink>

                        </div>
						</div>

                </div>
                <!-- End row -->

                <div class="row">

                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-10 offset-md-1 sect_tuto">
                     <img src="@/assets/images/tuto4.webp" class="im_tuto">
                    </div>
                    <!-- END  QUESTIONS HOLDER -->

                    <div class="col-lg-10 offset-lg-1">
                        <div class="press-txt text-center m-top-20">

                            <!-- Button -->
                            <RouterLink to="" class="btn btn-lightorange tuto-space " @click="ytb_tutos('https://www.youtube.com/embed/fh1-nM3KBJg')"><span class="pe-7s-play color_v"></span> Regarder le tuto</RouterLink>

                        </div>
						</div>

                </div>
                <!-- End row -->

                <div class="row">

                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-10 offset-md-1 sect_tuto">
                     <img src="@/assets/images/tuto5.webp" class="im_tuto">
                    </div>
                    <!-- END  QUESTIONS HOLDER -->

                    <div class="col-lg-10 offset-lg-1">
                        <div class="press-txt text-center m-top-20">

                            <!-- Button -->
                            <RouterLink to="" class="btn btn-lightorange tuto-space " @click="ytb_tutos('https://www.youtube.com/embed/0gT5FJPiXLw')"><span class="pe-7s-play color_v"></span> Regarder le tuto</RouterLink>

                        </div>
						</div>

                </div>
                <!-- End row -->

                <div class="row">

                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-10 offset-md-1 sect_tuto">
                     <img src="@/assets/images/tuto6.webp" class="im_tuto">
                    </div>
                    <!-- END  QUESTIONS HOLDER -->

                    <div class="col-lg-10 offset-lg-1">
                        <div class="press-txt text-center m-top-20">

                            <!-- Button -->
                            <RouterLink to="" class="btn btn-lightorange tuto-space " @click="ytb_tutos('https://www.youtube.com/embed/UVbOAdWNzHM')"><span class="pe-7s-play color_v"></span> Regarder le tuto</RouterLink>

                        </div>
						</div>

                </div>
                <!-- End row -->


                <div class="row">

                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-10 offset-md-1 sect_tuto">
                     <img src="@/assets/images/tuto7.webp" class="im_tuto">
                    </div>
                    <!-- END  QUESTIONS HOLDER -->

                    <div class="col-lg-10 offset-lg-1">
                        <div class="press-txt text-center m-top-20">

                            <!-- Button -->
                            <RouterLink to="" class="btn btn-lightorange tuto-space " @click="ytb_tutos('https://www.youtube.com/embed/RWlwxcMkrAU')"><span class="pe-7s-play color_v"></span> Regarder le tuto</RouterLink>

                        </div>
						</div>

                </div>
                <!-- End row -->


                <div class="row">

                <!-- QUESTIONS HOLDER -->
                <div class="col-lg-10 offset-md-1 sect_tuto">
                <img src="@/assets/images/tuto8.webp" class="im_tuto">
                </div>
                <!-- END  QUESTIONS HOLDER -->

                <div class="col-lg-10 offset-lg-1">
                    <div class="press-txt text-center m-top-20">

                        <!-- Button -->
                        <RouterLink to="" class="btn btn-lightorange tuto-space " @click="ytb_tutos('https://youtube.com/embed/D7XdgmzND1s')">
                            <span class="pe-7s-play color_v"></span>
                            Regarder le tuto
                        </RouterLink>

                    </div>
                    </div>

                </div>
                <!-- End row -->


            </div>	   <!-- End container -->
			</section>
        <!-- Mentions legales -->



        <footer_menu></footer_menu>
    </div>

</template>

<script>
import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
export default{
    name :'nos_cartes',
    components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu
    },

    methods: {

  ytb_tutos(lien){

        this.$swal.fire({
                title: false,
                icon: false,
                html:'<iframe width="740" height="400" src="'+lien+'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
                showCloseButton: false,
                showCancelButton: false,
                focusConfirm: false,
                confirmButtonText:'Fermer',
                confirmButtonAriaLabel: false,
                cancelButtonText: false,
                cancelButtonAriaLabel: false,
                width: '800px',
                padding: '10px',
                confirmButtonColor:'#261b64',
            })
    }


}
}


</script>

<style scoped>
.pro_part{
    background: url(@/assets/images/pic-pro-interne.png);
}
.sct_bck{
    background: url(@/assets/images/95b26da8.png) no-repeat;
}
.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}
.btn-lightorange {
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}
#download-2 .bg-inner {
    /* background-image: url(../images/download-2.jpg); */
    position: relative;
    z-index: 1;
    background: #261b64;
}
.orange{
color: #ff9e00;
}
.h5-sm{
    color: #261b64;
}
.sect_tuto{
    height: 480px;
    border-radius: 5px;
    text-align: center;
}

.color_v{
    font-weight: bold;
}
.tuto-space{
    margin-bottom: 100px;
}
.im_tuto{
    max-width: 750px;
    width: 100%;
    border-radius: 10px;
    border: 5px solid #e7e7e7;
}


@media screen and (max-width: 767px) {
    .sect_tuto {
    height: 240px;
    border-radius: 5px;
    text-align: center;
    }
    .tuto-space{
    margin-bottom: 50px;
}
 }

</style>

